import { IntegrationFeature, IntegrationProviderId, IntegrationStatus, Markdown, SettingsConfig } from "../../../index";

type IntegrationProps = {
  id: string;
  name: string;
  description: Markdown;
  providerId: IntegrationProviderId;
  status: IntegrationStatus;
  docsUrl: string;
  settingsConfig: SettingsConfig[];
	features: IntegrationFeature[];
};

class Integration {

  constructor(public _: IntegrationProps) {}

  static fromJson(json: any): Integration {
    return new Integration({
      id: json.id,
      name: json.name,
      description: json.description,
      providerId: json.provider_id,
      status: json.status as IntegrationStatus,
      docsUrl: json.docs_url,
      settingsConfig: json.settings_config.map((config: any) =>
        SettingsConfig.fromJson(config)
      ),
			features: json.features.map((feature: any) =>
				IntegrationFeature.fromJson(feature)
			),
    });
  }

	hasFeature(featureType: typeof IntegrationFeature): boolean {
		return this._.features.some((feature) => feature instanceof featureType);
	}

	featureById(id: string): IntegrationFeature | undefined {
		return this._.features.find((feature) => feature.id === id);
	}
}

interface IntegrationsCatalogProps {
  integrations: Integration[];
}

class IntegrationsCatalog {
  constructor(private _: IntegrationsCatalogProps) {}

  get integrations() {
    return this._.integrations;
  }

  findById(id: string): Integration | undefined {
    return this.integrations.find((integration) => integration._.id === id);
  }

}

export { Integration, IntegrationsCatalog };
